export const OrderDetailsOrderTypeMessages = {
  'en-US': {
    orderType: {
      B2C: 'B2C',
      Kitting: 'Kitting'
    }
  }
}
